import type {
  ExpenseClaimRouteResponse,
  TravelMovementResponse
} from 'generated/index';

export function isTravelMovementResponse(
  route: ExpenseClaimRouteResponse | TravelMovementResponse
): route is TravelMovementResponse {
  return 'fromDescription' in route && 'toAddress' in route;
}

export function isExpenseClaimRouteResponse(
  route: ExpenseClaimRouteResponse | TravelMovementResponse
): route is ExpenseClaimRouteResponse {
  return 'from' in route && 'to' in route;
}
